import css from "./ExciterDeviceEditor.sass?inline"
import {DeviceHost, ExciterDeviceBoxAdapter} from "@opendaw/studio-adapters"
import {Lifecycle} from "@opendaw/lib-std"
import {createElement} from "@opendaw/lib-jsx"
import {DeviceEditor} from "@/ui/devices/DeviceEditor.tsx"
import {MenuItems} from "@/ui/devices/menu-items.ts"
import {DevicePeakMeter} from "@/ui/devices/panel/DevicePeakMeter.tsx"
import {Html} from "@opendaw/lib-dom"
import {StudioService} from "@/service/StudioService"
import {EffectFactories} from "@opendaw/studio-core"
import {ControlBuilder} from "@/ui/devices/ControlBuilder"

const className = Html.adoptStyleSheet(css, "ExciterDeviceEditor")

type Construct = {
    lifecycle: Lifecycle
    service: StudioService
    adapter: ExciterDeviceBoxAdapter
    deviceHost: DeviceHost
}

export const ExciterDeviceEditor = ({lifecycle, service, adapter, deviceHost}: Construct) => {
    const {project} = service
    const {editing, midiLearning} = project
    const {frequency, drive, blend, mix} = adapter.namedParameter
    return (
        <DeviceEditor lifecycle={lifecycle}
                      project={project}
                      adapter={adapter}
                      populateMenu={parent => MenuItems.forEffectDevice(parent, service, deviceHost, adapter)}
                      populateControls={() => (
                          <div className={className}>
                              {[
                                  ControlBuilder.createKnob({
                                      lifecycle, editing, midiLearning, adapter, parameter: frequency, anchor: 0.5,
                                      style: {gridColumn: "1"}
                                  }),
                                  ControlBuilder.createKnob({
                                      lifecycle, editing, midiLearning, adapter, parameter: drive, anchor: 0.0,
                                      style: {gridColumn: "2"}
                                  }),
                                  ControlBuilder.createKnob({
                                      lifecycle, editing, midiLearning, adapter, parameter: blend, anchor: 0.0,
                                      style: {gridColumn: "3"}
                                  }),
                                  ControlBuilder.createKnob({
                                      lifecycle, editing, midiLearning, adapter, parameter: mix, anchor: 1.0,
                                      style: {gridColumn: "4"}
                                  })
                              ]}
                          </div>
                      )}
                      populateMeter={() => (
                          <DevicePeakMeter lifecycle={lifecycle}
                                           receiver={project.liveStreamReceiver}
                                           address={adapter.address}/>
                      )}
                      icon={EffectFactories.AudioNamed.Exciter.defaultIcon}/>
    )
}
